import React from 'react';
import './ProductCatagories.css';
import { Link } from "react-router-dom";
import Domestic from './img4.jpg'
const ProductCategories = () => {
  return (
    <div className="mainHome-container1">

        <div className="ALLOYMETALS-herosection" >
            <div className="NonFerrousMETALS-herosection-pic">
                <div className="ALLOYMETALS-herosection-heading">
                    HOME / Non Ferrous Metal Scrap
                </div>
            
            </div>
            
        </div>
        <div className="Each-Product-container" >
        

            <div className="Each-Product-mid-left-container">
                <div className='Each-Product-tittle'>
                FERROUS METALS
                </div>
                <div className='Each-Product-mid-details'>
                Our ferrous metal scrap products, containing iron and magnetic properties, are ideal for construction, manufacturing, and infrastructure projects. These materials ensure durability, versatility, and sustainability, supporting various industrial applications while promoting eco-friendly practices through efficient recycling and resource utilization.
                                </div>
            </div>
            <div className="Each-Product-mid-right-container">
                <div className="tranding-pics">
                    <img src={Domestic} alt="" className='tranding-left-pics' />
                </div>

            </div>
        </div>
    <section className="Each-Product-Details-card" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>Import Scrap</h2>
      
      <section className="product-categories-list">
      <div className="product-categories-list-header">
        
      </div>

      <div className="product-categories-list-grid">
        {productCategoryDetails.map((productCategory, index) => (
          <div key={index} className="product-categories-list-box">
            <div className="Each-product-benifitt-icon"><img src={productCategory.image} alt={productCategory.image} className='Each-Product-Details-card-img'/></div>
            <h3>{productCategory.title}</h3>
            <p>{productCategory.description}</p>
          </div>
        ))}
      </div>
    </section>
      {/* <button className="view-button">View All Products</button> */}
      {/* <h2 className='Product-category-title'>Browse by Category</h2> */}
    </section>
    
    </div>
  );
};

export default ProductCategories;

const productCategoryDetails = [
  {
    title: "Copper Scrap",
    description: "We offer copper wire scrap, clean copper tubing, and copper-based alloys, widely used in electrical manufacturing and construction projects. Copper is highly recyclable and holds its value in the market.",
    image: "/Products/Nonf/1.webp"
  },
  {
    title: "Aluminium Scrap",
    description: "Our aluminium scrap comes in various forms, including extrusions, rims, and cans. Aluminium is lightweight, corrosion-resistant, and widely used in automotive, aerospace, and packaging industries.",
    image: "/Products/Nonf/2.jpg"
  },
  {
    title: "Brass Scrap",
    description: "Brass, made of copper and zinc, is an important non-ferrous metal used in plumbing, electrical components, and decorative items. We provide clean, high-quality brass scrap for manufacturers and recyclers.",
    image: "/Products/Nonf/3.avif"
  },
  {
    title: "Lead Scrap",
    description: "We offer lead scrap sourced from batteries, pipes, and other materials. Lead is valuable in certain manufacturing processes and is fully recyclable.",
    image: "/Products/Nonf/4.jpg"
  },
  {
    title: "Zinc Scrap",
    description: "Sourced from zinc alloys and products, we provide zinc scrap that is used in a variety of applications, from die-casting to galvanizing processes.",
    image: "/Products/Nonf/5.webp"
  },

    
  ];
  